// Mobile/platform detection and deep link utilities for Slate
const APP_SCHEME = 'goslate://';
const APP_DOMAIN = 'https://app.goslate.io';
const IOS_STORE = 'https://apps.apple.com/app/slate-project-os/id0000000000';
const ANDROID_STORE = 'https://play.google.com/store/apps/details?id=io.goslate.slate';

export function isMobile() {
  if (typeof navigator === 'undefined') return false;
  return /Android|iPhone|iPad|iPod|Opera Mini|IEMobile|WPDesktop/i.test(navigator.userAgent);
}

export function isIOS() {
  if (typeof navigator === 'undefined') return false;
  return /iPhone|iPad|iPod/i.test(navigator.userAgent);
}

export function isAndroid() {
  if (typeof navigator === 'undefined') return false;
  return /Android/i.test(navigator.userAgent);
}

export function getStoreUrl() {
  if (isIOS()) return IOS_STORE;
  if (isAndroid()) return ANDROID_STORE;
  return IOS_STORE; // default fallback
}

/**
 * Redirect to the appropriate app store.
 * Deep link attempt is disabled until native app is published.
 */
export function openAppOrStore() {
  window.open(getStoreUrl(), '_blank', 'noopener');
}

export { APP_SCHEME, APP_DOMAIN, IOS_STORE, ANDROID_STORE };
